<template>
    <div>
        <np-responsive v-if="mode == 'inline'" :split="split">
            <template v-slot:label>
                <span v-html="label"  style="font-weight: bold"></span>
            </template>
            <template #labelhelptext>
            <span v-if="!!helpText">
                <span  :title="label"
                       :data-popover-content="helpText"
                       class="np-popover helpBtn addPopover helpHeader">
                    <i tabindex="-1" class="fa fa-info-circle"></i> </span>
            </span>
            </template>
            <template v-slot:input>
            <div class="form-group">
                <i v-if="iconClass" style="min-width:15px" :class="iconClass" v-tooltip="iconTooltip"> </i>
                <span class="preserve-whitespace" style="word-break: break-word;" v-if="formatter" v-html="formatter(modelValue)"></span>
                <span class="preserve-whitespace" style="word-break: break-word;" v-else v-html="entryValue"></span>
            </div>
            </template>
        </np-responsive>
        <span class="form-group input-group inputStyle" v-else-if="mode == 'input'">
            <span class="input-group-addon grouped" style="background-color: grey; border: grey;" v-if="hasAddon() && (addonOnLeft || hasExtraAddon())">{{addon}}</span>
            <label class="form-control preserve-whitespace" style="line-height: 20px; cursor: not-allowed;" v-text="entryValue"></label>
            <span class="input-group-addon grouped" style="background-color: grey; border: grey;"  v-if="hasAddon() && !addonOnLeft && !hasExtraAddon() ">{{addon}}</span>
            <span class="input-group-addon grouped" style="background-color: grey; border: grey;"  v-if="hasExtraAddon()">{{addon2}}</span>
        </span>
        <div class="panel-sub-heading headingSmall " v-else-if="mode == 'help_header'">
            <span class="markedBottom">{{label}}
                <a data-popover-placement="" :data-popover-title="!!modelValue ? modelValue.split('||')[0] : ''" :data-popover-content="!!modelValue ? modelValue.split('||')[1] : ''" href="#" class="helpBtn addPopover helpHeader">
                    <i tabindex="-1" class="fa fa-info-circle"></i>
                </a>
            </span>
        </div>
        <div class="panel-sub-heading headingSmall " v-else-if="mode == 'sub_heading'">
            <span class="markedBottom">{{label}}
            </span>
        </div>
        <div class="panel-sub-heading headingSmall " v-else-if="mode == 'sub_heading_no_bottom'">
            <span>{{label}}</span>
        </div>
        <a v-else-if="mode == 'help'" data-popover-placement="" :data-popover-title="label" :data-popover-content="modelValue" href="#" class="helpBtn addPopover helpHeader">
            <i tabindex="-1" class="fa fa-info-circle"></i>
        </a>
        <div :class="{'row': isFull}" v-else>
            <div class="summary_informationStyle col-12 summaryPadding" :class="{'col-md-6': !isFull, 'summarySmall': !isBig}">
                <span v-html="label"></span>
                <i v-if="iconClass" style="min-width:15px" :class="iconClass" v-tooltip="iconTooltip"> </i>
                <slot name="content"></slot>
                <span style="display: inline; word-break: break-word;" class="entry-text preserve-whitespace" :class="[textClass, {'main_desc': isBig}]" v-html="entryValue"></span>
            </div>
        </div>
    </div>
</template>

<script>

    import NpResponsive from "./np-responsive.vue";
    export default {
        name: 'np-entry',
        props: {
            label: String,
            mode: String,
            modelValue: {
                default: '-'
            },
            addon: {
                default: ''
            },
            addon2: {
                default: ''
            },
            addonOnLeft: {
                default: true
            },
            isFull: {
                default: false
            },
            isBig: {
                default: false
            },
            textClass: {
                default : ''
            },
            helpText: {
                default: ''
            },
            helpTextPosition: {
                default: 'description' // 'description' , 'label'
            },
            popover: {
                default: () => {
                    return false
                }   // example {'title': 'my title', 'content': 'my content'}
            },
            split: Number,
            popvalue: String,
            poptitle: String,
            iconClass: String,
            iconTooltip: String,
            formatter: Function
        },
        computed: {
            iconAttrs: function() {
                if (this.iconTooltip) {
                    return {
                        'data-bs-toggle': 'tooltip',
                        'data-bs-placement': 'top',
                        'title': this.iconTooltip
                    }
                } else {
                    return {};
                }
            },
            entryValue: function() {
                if(!!this.formatter) {
                    let formatted_value = this.formatter(this.modelValue);
                    return formatted_value !== '' ? formatted_value : '-';
                } else {
                    return this.modelValue !== '' ? this.modelValue : '-';
                }
            }
        },
        methods: {
            hasAddon: function() {
                return this.addon !== '';
            },
            hasExtraAddon: function() {
                return this.addon2 !== '';
            },
        },
        components: {
            NpResponsive
        }
    };
</script>

<style scoped>
    .summaryPadding {
        padding-bottom: 10px;
    }
    .info-balance .entry-text {
        color: #545959!important;
        font-style: italic;
        font-weight: bold;
        /*position: relative;*/
    }
    .mixed-balance .entry-text {
        color: #D43900 !important;;
        /*position: relative;*/
    }
</style>
